import Vue from 'vue'
import Vuex from 'vuex'
import { createModule } from 'vuex-toast'
import 'vuex-toast/dist/vuex-toast.css'

import commons from './modules/commons'
import workouts from './modules/workouts'
import warmups from './modules/warmups'
import stretchflows from './modules/stretch-flows'
import scripts from './modules/scripts'
import recipes from './modules/recipes'
import user from './modules/user'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    workouts,
    warmups,
    scripts,
    stretchflows,
    commons,
    recipes,
    user,
    toast: createModule({
      dismissInterval: 8000
    })
  },
  strict: debug,
//   plugins: debug ? [createLogger()] : []
})